"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLanguageSection = renderLanguageSection;
var _litHtml = require("lit-html");
var _solidUi = require("solid-ui");
var _LanguageEditDialog = require("./LanguageEditDialog");
var _profileIcons = require("../../icons-svg/profileIcons");
var _texts = require("../../texts");
var _collapsibleSection = require("../shared/collapsibleSection");
function renderLan(language, asList = false) {
  if (!language) return (0, _litHtml.html)``;
  return asList ? (0, _litHtml.html)`<li class="languages__item-label" role="listitem">${language.name}</li>` : (0, _litHtml.html)``;
}
function renderLanguages(languages, asList = false) {
  if (!languages || !languages.length || !languages[0]) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderLan(languages[0], asList)}${languages.length > 1 ? renderLanguages(languages.slice(1), asList) : (0, _litHtml.html)``}`;
}
function renderLanguagesSectionDefault(store, subject, languages, viewerMode, onSaved) {
  const hasLanguages = Array.isArray(languages) && languages.length > 0;
  const hasLanguageLinks = store.each(subject, _solidUi.ns.schema('knowsLanguage')).length > 0;
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
    <section
      class="profile__section border-lighter profile-section-collapsible profile-section-collapsible--inline-mobile-actions"
      aria-labelledby="languages-heading"
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="languages-heading">${_texts.languagesHeadingText}</h2>
        <div class="profile-section-collapsible__actions flex-column">
          ${isOwner ? (0, _litHtml.html)`
            <button
              type="button"
              class="profile__action-button profile-action-text flex-center profile-section-collapsible__edit-button"
              aria-label="Add or edit languages"
              @click=${event => (0, _LanguageEditDialog.createLanguageEditDialog)(event, store, subject, languages, viewerMode, onSaved)}
            >
              <span class="profile-section-collapsible__edit-label profile__add-more-content inline-flex-row">
                <span class="profile__add-more-icon inline-flex-row" aria-hidden="true">${_profileIcons.addIcon}</span>
                Add More
              </span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </button>
          ` : (0, _litHtml.html)``}
          <button
            type="button"
            class="inline-flex-row"
            aria-label="Toggle languages section"
            aria-controls="languages-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span class="profile-section-collapsible__chevron" aria-hidden="true">⌄</span>
          </button>
        </div>
      </header>
      <div id="languages-panel" class="profile-section-collapsible__content" aria-hidden="true">
        ${hasLanguages ? (0, _litHtml.html)`
              <ul class="languages__list" role="list" aria-label="Known languages">
                ${renderLanguages(languages, true)}
              </ul>
            ` : hasLanguageLinks ? (0, _litHtml.html)`<p>Language details are missing for one or more entries.</p>` : (0, _litHtml.html)`<p>No languages added yet.</p>`}
      </div>
    </section>
  `;
}
function renderOwnerEmptyLanguagesContent(_store, _subject, _languages, _viewerMode, _onSaved) {
  return (0, _litHtml.html)`
      <div class="profile__empty-state-content flex-column-center" role="group" aria-label="Empty languages section">    
        <div class="languages__empty-icon-wrapper">
          <span class="languages__empty-icon inline-flex-row">${_profileIcons.commentIcon}</span>
        </div>
        <p class="profile__empty-state-message languages__empty-message">
            No languages added yet.
        </p>
      </div>
  `;
}
function renderOwnerEmptyLanguagesSection(store, subject, languages, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="languages-heading" 
      data-profile-section="languages"
      class="profile__section--empty border-lighter rounded-md gap-lg profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="languages-heading" tabindex="-1">${_texts.languagesHeadingText}</h2>
        <div class="profile-section-collapsible__actions flex-column">
          <button
            type="button"
            class="profile__action-button profile-action-text flex-center profile-section-collapsible__edit-button"
            aria-label="Add languages"
            @click=${event => {
    return (0, _LanguageEditDialog.createLanguageEditDialog)(event, store, subject, languages, viewerMode, onSaved);
  }}
          >
            <span class="profile-section-collapsible__edit-label profile__add-more-content inline-flex-row">
              <span class="profile__add-more-icon inline-flex-row" aria-hidden="true">${_profileIcons.addIcon}</span>
              Add Languages
            </span>
            <span class="profile-section-collapsible__edit-icon profile-section-collapsible__edit-icon--add" aria-hidden="true">${_profileIcons.plusIcon}</span>
          </button>
          <button
            type="button"
            class="inline-flex-row"
            aria-label="Toggle languages section"
            aria-controls="languages-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span class="profile-section-collapsible__chevron" aria-hidden="true">⌄</span>
          </button>
        </div>
      </header>
      <div id="languages-panel" class="profile-section-collapsible__content" aria-hidden="true">
        ${renderOwnerEmptyLanguagesContent(store, subject, languages, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderLanguageSection(store, subject, languages, viewerMode, onSaved) {
  const safeLanguages = languages || [];
  const hasLanguages = Array.isArray(safeLanguages) && safeLanguages.length > 0;
  const showOwnerEmptyLanguages = !hasLanguages && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyLanguages ? renderOwnerEmptyLanguagesSection(store, subject, safeLanguages, viewerMode, onSaved) : renderLanguagesSectionDefault(store, subject, safeLanguages, viewerMode, onSaved)}
  ` : '';
}